<template>
  <div>
    <p v-if="category?.length || edited">Category code</p>
    <div class="_display:flex _flex-wrap:wrap _align-items:center">
      <i-badge
        color="primary"
        v-for="(attr, index) in category"
        :key="index"
        am-tag-badge
        class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
      >
        <p>{{ attr }}</p>
        <div v-if="edited" class="_display:flex _align-items:center">
          <svg am-icon @click="delCategory(index)" viewBox="0 0 24 24" style="fill: var(----color);">
            <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
      </i-badge>
      <svg v-if="edited && !isActive" am-icon viewBox="0 0 24 24" @click="isActive = true">
        <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
      </svg>
    </div>
    <hr>
    <div v-click-outside="() => isActive = false" class="_display:flex _flex-wrap:wrap" v-if="isActive">
      <i-badge
        v-for="cat in allCat"
        :key="cat.id"
        am-tag-badge
        class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
        @click="addCat(cat.code)"
      >
        <p>{{ cat.code }}</p>
        <div class="_display:flex _align-items:center">
          <svg
            viewBox="0 0 24 24"
            am-icon="color"
            class="_margin-left:1/4"
          >
            <use xlink:href="@/assets/icons.svg#plus2" x="0" y="0" width="24" height="24" />
          </svg>
        </div>
      </i-badge>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue'
import { useStore } from 'vuex'
const emit = defineEmits(['add', 'del'])
const store = useStore()
const props = defineProps(['category', 'edited', 'id'])
const allCat = computed(() => {
  return store.getters['partCategories/subCategory'](1).filter(el => !props.category.includes(el.code))
})
const isActive = ref(false)
const addCat = (code) => {
  emit('add', code)
  store.dispatch('formula/putParEdited', { id: props.id, data: props.category, tag: 'category_codes' })
}
const delCategory = (index) => {
  emit('del', index)
  store.dispatch('formula/putParEdited', { id: props.id, data: props.category, tag: 'category_codes' })
}
</script>
